import { createStandardAction, createAsyncAction } from "typesafe-actions";
import { QuoteResponse } from "../../lib/model/QuoteResponse";
import { QuoteRequest } from "../../lib/model/QuoteRequest";
import { BookDirectOrder } from "./model/BookDirectOrder";
import { CreateOrderRequest } from "../../lib/model/CreateOrderRequest";
import { Order } from "../../lib/model/Order";

export const updateOrder = createStandardAction("directBooking/UPDATE").map(
  (order: BookDirectOrder) => ({
    payload: order
  })
);

export const resetOrder = createStandardAction("directBooking/RESET_ORDER")();

export const resetQuote = createStandardAction("directBooking/RESET_QUOTE")();

export const fetchQuoteAsync = createAsyncAction(
  "directBooking/FETCH_QUOTE_REQUEST",
  "directBooking/FETCH_QUOTE_SUCCESS",
  "directBooking/FETCH_QUOTE_FAILURE"
)<QuoteRequest, QuoteResponse, Error>();

export const createOrderAsync = createAsyncAction(
  "directBooking/CREATE_ORDER_REQUEST",
  "directBooking/CREATE_ORDER_SUCCESS",
  "directBooking/CREATE_ORDER_FAILURE"
)<CreateOrderRequest, Order, Error>();
